import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";
import { IdProps } from "../../interfaces/Global";

const MainTable = () => {
  const actionButtons = ["add", "edit", "remove", "export"];
  return (
    <LmsTable
      actionButtons={actionButtons}
      apiSuffix="menu/loan-draw-batch"
      deleteSuffix="menu/loan-draw-batch"
      sortable={["Created On"]}
      columnLabelsDictionary={{
        achdate: "ACH Date",
        achdrawsFundedCount: "ACH Draws Funded Count",
        achamountFunded: "ACH Amount Funded",
        achbudgetDraw: "ACH Budget Draw",
        achwireFee: "ACH Wire Fee",
        achdatedownFee: "ACH Date Down Fee",
        achinspectionFee: "ACH Inspection Fee",
        achinspectionSiteVisitFee: "ACH Inspection Site Visit Fee",
        lppaymentDate: "LP Payment Date",

      }}
    />
  );
};

const loanDrawBatchFormFields = (myForm: BCFormController, isEdit = false) => {
  myForm.addCenteredGroup([
    myForm.getInputField("JE", { name: "je", fieldType: "number", required: true, disabled: isEdit }),
    myForm.getCalendarField("LP Payment Date"),
  ]);

  myForm.addCenteredGroup([myForm.getCalendarField("Wire Date"), myForm.getCalendarField("Check Date")]);
  myForm.addCenteredGroup([
    myForm.getInputField("Wire Draws Funded Count", { fieldType: "number" }),
    myForm.getInputField("Check Draws Funded Count", { fieldType: "number" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Total Draws Funded Count", { fieldType: "number" }),
    myForm.getInputField("Wire Amount Funded", { fieldType: "dollar" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Check Amount Funded", { fieldType: "dollar" }),
    myForm.getInputField("Total Amount Funded", { fieldType: "dollar" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Wire Budget Draw", { fieldType: "dollar" }),
    myForm.getInputField("Check Budget Draw", { fieldType: "dollar" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Wire Wire Fee", { fieldType: "dollar" }),
    myForm.getInputField("Wire Datedown Fee", { fieldType: "dollar" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Wire Inspection Fee", { fieldType: "dollar" }),
    myForm.getInputField("Check Wire Fee", { fieldType: "dollar" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Check Datedown Fee", { fieldType: "dollar" }),
    myForm.getInputField("Check Inspection Fee", { fieldType: "dollar" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Total Budget Draw", { fieldType: "dollar" }),
    myForm.getInputField("Total Wire Fee", { fieldType: "dollar" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Total Datedown Fee", { fieldType: "dollar" }),
    myForm.getInputField("Total Inspection Fee", { fieldType: "dollar" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Description"),
  ]);

  return myForm;
};

const EditNewMenusLoanDrawBatchForm = ({ id }: IdProps) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`menu/loan-draw-batch/${id}`);
  const myForm = loanDrawBatchFormFields(new BCFormController(data, { 
    submitSuffix: "menu/loan-draw-batch", 
    submitMethod: "PUT",
    deleteSuffix: "menu/loan-draw-batch",
  }), true);
  const formActions = ["save", "save-close", "delete", "close"];
  return (
    <LmsFormGenerator
      myForm={myForm}
      isLoading={isLoading}
      error={error}
      actions={formActions}
    />
  );
};

const AddNewMenusLoanDrawBatchForm = () => {
  const myForm = loanDrawBatchFormFields(new BCFormController({}, { 
    submitSuffix: "menu/loan-draw-batch", 
    submitMethod: "POST", 
    blankWidth: 4 
  }));  
  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return (<LmsFormGenerator myForm={myForm} actions={formActions} />);
};

const LmsNewMenusLoanDrawBatch = ({
  params = {},
  history,
}) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <MainTable />}
      {isAdd && <AddNewMenusLoanDrawBatchForm />}
      {isEdit && <EditNewMenusLoanDrawBatchForm id={id} />}
    </>
  );
};

export default LmsNewMenusLoanDrawBatch;
